import { z } from "zod";

import { TokenUsageSchema } from "services/metricsApi/types/ChatRecordJson";

/**
 * Represents data from a 'usage' server-sent event from the Corteva Chat API.
 * Example (in a text stream):
 *   event: usage
 *   data: {"input_tokens": 1, "output_tokens": 2, "reasoning_tokens": 3, "cached_tokens": 4, "truncated_messages": 0, "history_tokens": 500}
 */
export const TokenUsageEventSchema = z.object({
  type: z.literal("usage"),
  data: TokenUsageSchema,
});

export type TokenUsageEvent = z.infer<typeof TokenUsageEventSchema>;
